import { batch } from 'react-redux'
import { makeActionCreator } from '../../config/store/utils'
import { getQuotePurchaseOrderChangeStatus } from '../../services/purchaseOrder'
import { QUOTE_STATUS_CANCELLED_AUTOMATICALLY } from '../../config/settings/constants'

export const OPEN_PURCHARSE_ORDER_CHANGE_STATUS_DIALOG = 'OPEN_PURCHARSE_ORDER_CHANGE_STATUS_DIALOG'
export const onOpenPurchaseOrderChangeStatusDialog = makeActionCreator(
  OPEN_PURCHARSE_ORDER_CHANGE_STATUS_DIALOG,
  'payload'
)

export const CLOSE_PURCHARSE_ORDER_CHANGE_STATUS_DIALOG = 'CLOSE_PURCHARSE_ORDER_CHANGE_STATUS_DIALOG'
export const onClosePurchaseOrderChangeStatusDialog = makeActionCreator(CLOSE_PURCHARSE_ORDER_CHANGE_STATUS_DIALOG)

export const GET_QUOTE_PURCHASE_ORDER_CHANGE_STATUS = 'GET_QUOTE_PURCHASE_ORDER_CHANGE_STATUS'
export const GET_QUOTE_PURCHASE_ORDER_CHANGE_STATUS_ERROR = 'GET_QUOTE_PURCHASE_ORDER_CHANGE_STATUS_ERROR'
export const GET_QUOTE_PURCHASE_ORDER_CHANGE_STATUS_SUCCESS = 'GET_QUOTE_PURCHASE_ORDER_CHANGE_STATUS_SUCCESS'
export const onGetQuotePurchaseOrderChangeStatus = makeActionCreator(GET_QUOTE_PURCHASE_ORDER_CHANGE_STATUS)
export const onGetQuotePurchaseOrderChangeStatusError = makeActionCreator(
  GET_QUOTE_PURCHASE_ORDER_CHANGE_STATUS_ERROR,
  'payload'
)
export const onGetQuotePurchaseOrderChangeStatusSuccess = makeActionCreator(
  GET_QUOTE_PURCHASE_ORDER_CHANGE_STATUS_SUCCESS,
  'payload'
)

export const onGetQuotePurchaseOrderChangeStatusThunk = () => async dispatch => {
  dispatch(onGetQuotePurchaseOrderChangeStatus())

  try {
    const { data } = await getQuotePurchaseOrderChangeStatus()

    const QuotePurcharseOrderChangeStatus = [
      ...(data?.payload?.pendientesOC?.map(purcharseOrder => ({
        code: purcharseOrder?.codigoSolicitud,
        codePO: purcharseOrder?.codigoOc,
        name: purcharseOrder?.nombreSolicitud,
        namePO: purcharseOrder?.nombreOc,
        status: purcharseOrder?.estadoOC,
        statusId: purcharseOrder?.idEstadoOC,
        cancelAutomatic: QUOTE_STATUS_CANCELLED_AUTOMATICALLY.CANCELLED
      })) || []),

      ...(data?.payload?.cancelacionesAuto?.map(cancellation => ({
        code: cancellation?.codigoSolicitud,
        name: cancellation?.nombreSolicitud,
        cancelDate: cancellation?.fechaCancelacion,
        status: QUOTE_STATUS_CANCELLED_AUTOMATICALLY.CANCELLED_AUTOMATICALLY,
        cancelAutomatic: QUOTE_STATUS_CANCELLED_AUTOMATICALLY.CANCELLED_AUT
      })) || [])
    ]

    return batch(() => dispatch(onGetQuotePurchaseOrderChangeStatusSuccess({ QuotePurcharseOrderChangeStatus })))
  } catch (error) {
    return dispatch(onGetQuotePurchaseOrderChangeStatusError({ error }))
  }
}
